import { render, staticRenderFns } from "./WebformDepartments.vue?vue&type=template&id=1cf4a4db&"
import script from "./WebformDepartments.vue?vue&type=script&lang=js&"
export * from "./WebformDepartments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports